export default __webpack_public_path__ + "static/media/overviewBannerMobile.3e96e2c3.png";